// Thank's IE8 for his funny defineProperty
module.exports = !require('./_fails')(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});



//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-react-next/~/core-js/modules/_descriptors.js
// module id = ./node_modules/gatsby-plugin-react-next/node_modules/core-js/modules/_descriptors.js
// module chunks = 168707334958949